import {AbstractService} from "@/services/AbstractService";
import {app} from "@/app";
import {AbstractShopifyPageObserver} from "@/services/observer/shopify/pages/AbstractShopifyPageObserver";

export class Common extends AbstractShopifyPageObserver {
    async init(): Promise<void> {
        app.storage.shopify.resolve();
        app.storage.pixel.resolve();
        app.pixel.log.clear();
    }

    isApplicable(): boolean {
        return true;
    }

    async resolve() {}

    async beforePageLoad() {
        await super.beforePageLoad();
        // await this.collectPixelContext();
    }

    async afterPageLoad() {
        if(app.pixel.log.items.length === 0) {
            await app.pixel.events.shopify.pageView.handle();
        }
    }
}
